var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import { clsx } from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
function Ticker(_a) {
    var text = _a.text, _b = _a.gap, gap = _b === void 0 ? 16 : _b, _c = _a.glideSpeed, glideSpeed = _c === void 0 ? 1 : _c, backgroundColorStyle = _a.backgroundColorStyle, _d = _a.theme, theme = _d === void 0 ? 'light' : _d;
    var tickerRef = useRef(null);
    var shouldAnimateRef = useRef(false);
    var _e = useState(0), distance = _e[0], setDistance = _e[1];
    var _f = useState([]), shiftCounters = _f[0], setShiftCounters = _f[1];
    var currentImageIndexRef = useRef(0);
    var distanceRef = useRef(0);
    var widthOfAllTextComponents = useRef(0);
    var textStyle = theme === 'dark' ? 'text-text-white' : 'text-text-body';
    var textRefs = useRef([]);
    var numTextComponents = text instanceof Array ? text.length : 1;
    var numTextComponentsToRender = Math.floor(40 / numTextComponents) * numTextComponents;
    textRefs.current = Array.from(Array(numTextComponentsToRender)).map(function () { return React.createRef(); });
    // TODO: stop the animation loop if the component is unmounted or not visible
    var animate = function () {
        if (shouldAnimateRef.current) {
            widthOfAllTextComponents.current = textRefs.current.reduce(function (acc, textRef) {
                if (!textRef.current) {
                    return acc;
                }
                return acc + textRef.current.offsetWidth;
            }, textRefs.current.length * gap);
            setDistance(function (prevDistance) { return prevDistance - glideSpeed; });
            distanceRef.current = distanceRef.current - glideSpeed;
            if (textRefs.current[currentImageIndexRef.current] &&
                textRefs.current[currentImageIndexRef.current].current &&
                Math.abs(distanceRef.current) >
                    textRefs.current[currentImageIndexRef.current].current.offsetWidth + gap) {
                setShiftCounters(function (prevCounters) {
                    var newValue = (prevCounters[currentImageIndexRef.current] || 0) + 1;
                    prevCounters[currentImageIndexRef.current] = newValue;
                    currentImageIndexRef.current =
                        (currentImageIndexRef.current + 1) % textRefs.current.length;
                    distanceRef.current = widthOfAllTextComponents.current % glideSpeed;
                    return prevCounters;
                });
            }
        }
        requestAnimationFrame(animate);
    };
    useEffect(function () {
        if (textRefs.current.length > 0) {
            animate();
        }
        // use intersection observer to tell whether this component is visible
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                shouldAnimateRef.current = entry.isIntersecting;
            });
        });
        if (tickerRef.current) {
            observer.observe(tickerRef.current);
        }
        return function () {
            if (tickerRef.current) {
                observer.unobserve(tickerRef.current);
            }
        };
    }, [text, shiftCounters]);
    return (_jsx("div", __assign({ ref: tickerRef, className: clsx('relative w-full flex justify-start items-center overflow-hidden py-xl-m', "gap-x-[".concat(gap, "px]"), backgroundColorStyle, textStyle) }, { children: _jsx("div", __assign({ style: {
                transform: "translateX(".concat(distance, "px)"),
                columnGap: "".concat(gap, "px"),
            }, className: "flex justify-start" }, { children: textRefs.current.map(function (textRef, index) {
                return (_jsx("div", __assign({ ref: textRef, style: {
                        transform: "translateX(".concat((shiftCounters[index] || 0) * widthOfAllTextComponents.current, "px"),
                    }, className: "h-max shrink-0" }, { children: _jsx(Heading, __assign({ size: "sm", className: "uppercase" }, { children: text instanceof Array ? text[index % text.length] : text })) }), "text-".concat(index)));
            }) })) })));
}
export default Ticker;
